import { GridCellProps } from '@progress/kendo-react-grid';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase from 'src/components/GridCellBase';
import useDebounce from 'src/hooks/useDebounce';

const EndingBalanceCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const debouncedNewAmount = useDebounce(dataItem.newAmount, 1000);
  const displayValue = `$${
    (dataItem.card === 'add' ? +debouncedNewAmount : -debouncedNewAmount) +
    dataItem.remainingBudgetAmount
  }`;

  return (
    <GridCellBase
      {...props}
      title={displayValue}
      rowSelectionEnabled
      style={{
        ...validateNumber(field, dataItem),
        textAlign: 'right',
      }}
    >
      <span>{displayValue}</span>
    </GridCellBase>
  );
};

export default EndingBalanceCell;
